(function () {
    'use strict';

    angular
        .module('app.bestPerformingInfluencersReport')
        .controller('bestPerformingInfluencersReportCtrl', ['$location', '$scope', '$rootScope', '$state', 'measureService', 'bestPerformingInfluencersReportService', 'adminService', '$http', '$controller', 
            function ($location, $scope, $rootScope, $state, measureService, bestPerformingInfluencersReportService, adminService, $http, $controller)
            {
                $scope.enable = false;
                $scope.currentPage = 1;
                $scope.pageSize = 10;
                $scope.orderBy = "engagement";
                $scope.reverse = true;
                $scope.gotoBestPerformingInfluencers = false;
                $scope.bestPerformingInfluencers = [];
                $scope.bestPerformingInfluencersForPrint = [];
                $scope.getBestPerformingInfluencers = function(params)
                {
                    var result = null;
                    params.page_no = $scope.currentPage;
                    params.order_by = $scope.orderBy;
                    params.reverse = $scope.reverse;

                    bestPerformingInfluencersReportService.getBestPerformingInfluencers(params)
                        .then(function(result){
                            $scope.bestPerformingInfluencers = result.data;
                    
                            $scope.totalRow = result.totalRow;
                            $scope.pagination();
                            if($scope.currentPage==1)
                            {
                                $scope.bestPerformingInfluencersForPrint = $scope.bestPerformingInfluencers;
                            }
                            if($scope.gotoBestPerformingInfluencers)
                            {
                                $scope.gotoBestPerformingInfluencers = false;
                                setTimeout(function(){
                                     $('html,body').animate({scrollTop: $("#BestPerformingInfluencers").offset().top}, 0);
                                }, 200);
                                
                            }
                            // $scope.genBestPerformingInfluencers(result);
                        })
                        .catch(function(message){
                            $scope.bestPerformingInfluencers = [];
                            $scope.bestPerformingInfluencersForPrint = [];
                        })
                        .finally(function(){
                            $rootScope.$broadcast('sectionLoaded');
                        });
                }

                $scope.genBestPerformingInfluencers = function(result)
                {
                    $scope.bestPerformingInfluencers = result.data;
                    
                    $scope.totalRow = result.totalRow;
                    $scope.pagination();
                    if($scope.currentPage==1)
                    {
                        $scope.bestPerformingInfluencersForPrint = $scope.bestPerformingInfluencers;
                    }
                    if($scope.gotoBestPerformingInfluencers)
                    {
                        $scope.gotoBestPerformingInfluencers = false;
                        setTimeout(function(){
                             $('html,body').animate({scrollTop: $("#BestPerformingInfluencers").offset().top}, 0);
                        }, 200);
                        
                    }
                }

                $scope.$on('refreshDashboard', function(event, args)
                {
                    getDataBestPerformingInfluencersReport();
                });

                function getDataBestPerformingInfluencersReport()
                {
                    var params = $rootScope.saveParams;
                    if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0))
                    {
                        return;
                    }
                    params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

                    if(params.mention != 0 || params.project_id != 0) {
                        $scope.enable = true;
                    } else {
                        $scope.enable = false;
                    }

                    $scope.getBestPerformingInfluencers(params);
                }

                $scope.pagination = function()
                {
                    $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
                }

                $scope.updatePage = function(val)
                {
                    $scope.currentPage = val;
                    $scope.gotoBestPerformingInfluencers = true;
                    getDataBestPerformingInfluencersReport();
                }

                $scope.influencerOverviewPage = function(influencer_id)
                {
                    $rootScope.previousPage = $location.absUrl();
                    $state.transitionTo('home.influencerOverview',
                        {
                            influencer_id: influencer_id
                        },
                        {
                            reload: false,
                            inherit: true,
                            notify: true
                        }
                    );
                }

                $scope.sortMention = function()
                {
                    if($scope.orderBy == "mention") {
                        $scope.reverse = !$scope.reverse;
                    } else {
                        $scope.orderBy = "mention";
                        $scope.reverse = true;
                    }
                    
                    $scope.gotoBestPerformingInfluencers = true;
                    getDataBestPerformingInfluencersReport();
                }

                $scope.sortEngagement = function()
                {
                    if($scope.orderBy == "engagement") {
                        $scope.reverse = !$scope.reverse;
                    } else {
                        $scope.orderBy = "engagement";
                        $scope.reverse = true;
                    }

                    $scope.gotoBestPerformingInfluencers = true;
                    getDataBestPerformingInfluencersReport();
                }

                $scope.sortImpact = function()
                {
                    if($scope.orderBy == "impact") {
                        $scope.reverse = !$scope.reverse;
                    } else {
                        $scope.orderBy = "impact";
                        $scope.reverse = true;
                    }

                    $scope.gotoBestPerformingInfluencers = true;
                    getDataBestPerformingInfluencersReport();
                }

                // first initiating
                getDataBestPerformingInfluencersReport();
            }
        ]);
})();